import { render, staticRenderFns } from "./ProvincesConfig.vue?vue&type=template&id=40ee6729&scoped=true"
import script from "./ProvincesConfig.vue?vue&type=script&lang=js"
export * from "./ProvincesConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ee6729",
  null
  
)

export default component.exports